import React from 'react';
import { Separator } from './ui/separator';

const About = () => {
  return (
    <section className="py-12 md:py-16 max-w-2xl mx-auto">
      <Separator className="mb-12 md:mb-16 bg-border" />
      
      <h2 className="font-serif text-3xl md:text-4xl font-medium text-foreground mb-10 tracking-tight">
        In the beginning was the command line.
      </h2>
      
      <div className="space-y-8">
        <p className="font-serif text-lg md:text-xl text-foreground/90 leading-relaxed italic border-l-2 border-primary/20 pl-6 my-8">
          My relationship with computing didn't start with polished interfaces. It started with a flashing cursor and the smell of warm electronics.
        </p>

        <p className="font-sans text-base md:text-lg text-foreground/80 leading-relaxed">
          At age five in Argentina, I was introduced to a <span className="font-semibold text-foreground">Commodore 64</span>. While the world saw a toy, I saw a gateway. I spent my afternoons toggling between loading games from <span className="font-mono text-sm bg-muted px-1">5 1/4" floppies</span> and manually typing lines from the BASIC manual. 
        </p>
        
        <p className="font-sans text-base md:text-lg text-foreground/80 leading-relaxed">
          The epiphany came early: I built a stock management system (CRUD) for my father’s car dealership. Seeing the abstract logic of code manage the physical reality of a car lot taught me the only truth that matters: <span className="font-semibold text-foreground">Technology is irrelevant unless it solves a human problem.</span>
        </p>
        
        <p className="font-sans text-base md:text-lg text-foreground/80 leading-relaxed">
          From my roots in Rosario, I moved into the high-stakes world of international tech. I founded and led a remote-first organization to <span className="font-semibold text-foreground">$150K+ MRR</span>, managing over <span className="font-semibold text-foreground">60 specialists</span>—built entirely on grit, with <span className="font-semibold text-foreground">zero external capital</span>. No angels, no VCs, no debt. This purely bootstrapped journey culminated in a successful exit in 2024.
        </p>
        
        <p className="font-sans text-base md:text-lg text-foreground/80 leading-relaxed">
          But with growth came the entropy. I witnessed the <span className="italic">Noise Crisis</span> firsthand: a global talent market drowning in volume but starving for signal. Today, I’m building the <span className="font-semibold text-foreground">intelligent infrastructure</span> to fix it—leveraging AI not as a buzzword, but as a technical firewall to restore efficiency to the tech workforce.
        </p>

        <p className="font-sans text-base md:text-lg text-foreground/80 leading-relaxed">
          I operate at the intersection of venture building and technical strategy, ensuring that the next era of digital work is as scalable as it is precise.
        </p>
      </div>
    </section>
  );
};

export default About;